module.exports = __webpack_public_path__ + "img/zj4361_center_002.5ff90a3d.png";